import { render, staticRenderFns } from "./dashboardTagrisso.vue?vue&type=template&id=04ce67fe&"
import script from "./dashboardTagrisso.vue?vue&type=script&lang=js&"
export * from "./dashboardTagrisso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports